import PropTypes from 'prop-types';

import styles from '../Banner.module.css';
import CountDown from '../CountDown/CountDown';
const DoubleBannerWrapper = ({
  is_active,
  code,
  position,
  color,
  started_at,
  ended_at,
  now,
  is_external_url,
  external_url,
  image_url,
  className,
  onClick
}) => {
  if (is_external_url) {
    return (
      <div className={`${styles.HalfImageContainer} ${className}`}>
        <a className={styles.BannerLink} href={external_url}>
          <img alt="banner" className={styles.SingleImage} src={image_url} />
        </a>
      </div>
    );
  }
  return (
    <div className={`${styles.HalfImageContainer} ${className}`} onClick={onClick}>
      <img alt="banner" className={styles.SingleImage} src={image_url} />
      <CountDown
        code={code}
        color_code={color}
        ended_at={ended_at}
        is_active={is_active}
        now={now}
        position={position}
        started_at={started_at}
      />
    </div>
  );
};

DoubleBannerWrapper.propTypes = {
  now: PropTypes.string,
  started_at: PropTypes.string,
  ended_at: PropTypes.string,
  code: PropTypes.number,
  position: PropTypes.string,
  color: PropTypes.string,
  is_external_url: PropTypes.bool,
  external_url: PropTypes.string,
  image_url: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default DoubleBannerWrapper;
